import { render } from "./formSummary.vue?vue&type=template&id=28b5807e&scoped=true"
import script from "./formSummary.js?vue&type=script&lang=js"
export * from "./formSummary.js?vue&type=script&lang=js"

import "./formSummary.vue?vue&type=style&index=0&id=28b5807e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b5807e"]])

export default __exports__